import categoryMerchantsTable from './CategoryMerchantsTable';

export default categoryMerchantsTable;
